import { HttpErrorResponse } from '@angular/common/http';
import { Observable, ObservableInput, ObservedValueOf, OperatorFunction, throwError } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';
import * as Sentry from '@sentry/angular';
import { ApiError, ApiErrorResponse, isApiErrorArray } from '../models';
import { isNotNullish, isNotUndefined } from './types';

// from: https://medium.com/ngconf/filtering-types-with-correct-type-inference-in-rxjs-f4edf064880d

export const filterNotNullish =
	<T>(): OperatorFunction<T | null | undefined, T> =>
	(source$: Observable<T | null | undefined>) =>
		source$.pipe(filter(isNotNullish));

export const filterNotUndefined =
	<T>(): OperatorFunction<T | null | undefined, T | null> =>
	(source$: Observable<T | null | undefined>) =>
		source$.pipe(filter(isNotUndefined));

/**
 * @throws ApiError[]
 */
export const catchApiErrorAndRethrow =
	() =>
	<T>(source$: Observable<T>) =>
		source$.pipe(
			catchError((err: any) => {
				if (err instanceof HttpErrorResponse) {
					Sentry.withScope(scope => {
						scope.setTag('module', 'site.userService');
						scope.setExtra('error', err);
						Sentry.captureMessage('API error');
					});
					throw (err.error as ApiErrorResponse).errors ?? ([{ code: 'unknown-api-error' }] as ApiError[]);
				}
				throw err;
			})
		);

// export const catchApiError = <T, O extends ObservableInput<any>>(selector: (err: ApiError[], caught: Observable<T>) => O): OperatorFunction<T, T | ObservedValueOf<O>> => <T>(source$: Observable<T>) => source$.pipe(
// 	catchApiErrorAndRethrow(),
// 	catchError((err, caught) => {
// 		if (isApiErrorArray(err)) {
// 			return selector(err);
// 		}
// 		return throwError((error.error as ApiErrorResponse).errors ?? [ { code: 'unknown-api-error' } ] as ApiError[]);
// 	})
// );
